export interface FieldError {
    key: string;
    error: string;
}

export enum ErrorCode {
    FieldValidation = 'ERR001'
}
